angular.module('property')
    .component('propertyTechTypeSelect', {
        bindings: {
            multiple: '<',
            onChange: '&',
            required: "="
        },
        require: {
            ngModelCtrl: 'ngModel'
        },
        template: `
            <ol ng-if="$ctrl.multiple === true" class="nya-bs-select btn-sm" ng-model="$ctrl.selected" actions-box="true" data-selected-text-format="count>2"
                multiple size="10" title="{{ 'property.techType.select' | translate }}" ng-change="$ctrl.onSelectionChanged()"
                ng-model-options="{ updateOn: 'blur' }">
                <li nya-bs-option="option in $ctrl.items" deep-watch="true" data-value="option">
                    <a>{{option}}</a>
                </li>
            </ol>
            <ol ng-if="$ctrl.multiple !== true" class="nya-bs-select btn-sm" ng-model="$ctrl.selected" actions-box="true" data-selected-text-format="count>2"
                size="10" title="{{ 'property.techType.select' | translate }}" ng-change="$ctrl.onSelectionChanged()"
                ng-model-options="{ updateOn: 'blur' }">
                <li nya-bs-option="option in $ctrl.items" deep-watch="true" data-value="option">
                    <a>{{option}}</a>
                </li>
            </ol>
        `,
        controller: function (Property) {
            const ctrl = this;

            ctrl.$onInit = () => {
                ctrl.items = Property.techTypes()

                ctrl.ngModelCtrl.$render = () => ctrl.selected = ctrl.ngModelCtrl.$viewValue;
                ctrl.ngModelCtrl.$formatters.push(modelValue => modelValue);
                ctrl.ngModelCtrl.$parsers.push(viewValue => viewValue);
            };

            ctrl.onSelectionChanged = () => {
                ctrl.ngModelCtrl.$setViewValue(ctrl.selected);
                ctrl.ngModelCtrl.$validate();

                if (angular.isFunction(ctrl.onChange())) {
                    ctrl.onChange()(ctrl.selected);
                }
            };

        }
    })
